<style lang="scss">
.beat-page {
    min-height: 100vh;
    margin-top : 10px;
    .bg-image-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-image: linear-gradient(180deg, rgba(255, 255, 255, -0.5) 0%, #ffffff 100%);
        z-index: 1;
    }
    .bg-image {
        position: absolute;
        z-index: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 0;
        height: 50%;
        background-repeat: no-repeat;
        background-position: center top;
        background-size: cover;
        opacity: 0.3;
        filter: blur(4px);
    }
    .bg-image-gradient {
        position: absolute;
        bottom: 0;
        height: 50%;
        width: 100%;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
        background-repeat: repeat-x;
    }
    .page-content {
        position: relative;
        z-index: 10;
    }
    .search-bar .search-input-wrapper.search-only {
        margin: auto;
        padding: 45px 10px 45px 0px !important;
    }
    .top-section-wrapper {
        display: flex;
        margin-bottom: 40px;
        .beat-image-wrapper {
            flex: 1;
            position: relative;
            cursor: pointer;
        }
        .beat-image {
            border-radius: 5px;
            width: 100%;
        }
        .beat-info-wrapper {
            padding-left: 30px;
            flex: 2;
        }
        .beat-name-wrapper {
            display: flex;
            justify-content: space-between;
        }
        .beat-name-buttons {
            display: flex;
            margin-left: 10px;
            .download-button {
                color: #00d38a;
                margin-right: 5px;
            }
        }
        .general-info-wrapper {
            font-size: 14px;
            color: #595E63;
        }
        .general-info-item {
            padding: 10px 0;
            display: flex;
        }
        .general-info-title {
            color: #FF5B94;
            font-weight: 600;
            font-size: 20px;
        }
        .general-info-heading {
            min-width: 150px;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
            svg {
                font-size: 13px;
            }
        }
        .general-info-value {
            display: flex;
            flex-wrap: wrap;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 400;
        }
        .general-info-link {
            border-radius: 5px;
            border: 1px solid;
            padding: 2px 5px;
            font-size: 11px;
            margin-right: 5px;
            margin-bottom: 5px;
        }
    }

    .beat-name {
        color: #000000;
        font-family: Poppins;
        font-size: 30px;
        font-weight: 600;
    }

    .btn-playpause {
        background: #fff;
        color: #ff5b94;
        position: absolute !important;
        top: 3px !important;
        left: 3px !important;
        padding: 0 0px !important;
        font-size: 16px;
    }

    .item-overlay{
        top: 50% !important;
        left: 50% !important;
        margin-left: -31px !important;
        margin-top: -31px !important;
        opacity: 1 !important;
    }
    .quarter {
        width: 23px;
        height: 23px;
        background-color: #ffffff;
        opacity: 0.52;
    }

    .top-right {
        border-top-right-radius: 24px;
        border-bottom-right-radius: 3px;
        border-top-left-radius: 3px;
        position: absolute;
        right: 0;
        top: 0;
    }

    .bottom-left {
        border-bottom-left-radius: 40px;
        position: absolute;
        border-top-left-radius: 3px;
        border-bottom-right-radius: 3px;
        bottom: 0;
        left: 0;
    }

    #circle-container {
        width: 46px;
        height: 46px;
        position:relative;
        z-index:1;
    }

    .divider {
        border-bottom: 1px solid;
        opacity : 0.36;
    }

    .license-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .license-price {
            position: relative;
            color: #fff;
            width: 100px;
            &:hover {
                -webkit-filter: brightness(95%);
                filter: brightness(95%);
            }
        }
        .discount-icon-wrapper {
            position: absolute;
            right: -4px;
            bottom: -4px;
            border-radius: 50%;
            background: black;
            color: white;
            font-size: 11px;
            width: 15px;
            height: 15px;
            padding: 1px;
            font-weight: bold;
        }
    }

    .licenses-title {
        color: #FF5B94;
        margin-top: 40px;
        text-transform: uppercase;
        font-size: 30px !important;
    }

    .discounts-title {
        color: #FF5B94;
        margin-top: 40px;
        text-transform: uppercase;
        font-size: 30px !important;
    }
    .licenses-wrapper {
        display: flex;
        margin-left: -10px;
        margin-right: -10px;
        margin-bottom: 40px;
        .beat-license-container {
            flex: 1;
            max-width: 180px;
            min-width: 175px;
            margin: 10px 10px;
            height: 100%;
        }
    }

    .note{
        color: #595e63;
            font-family: Poppins;
            font-size: 11px;
            font-weight: 400;
    }

    .discounts-wrapper{
        display: flex;
        margin-left: -10px;
        margin-right: -10px;
        margin-bottom: 40px;
        align-items: flex-start;
        .beat-discount-container {
            flex: 1;
            max-width: 180px;
            margin: 0 10px;
            min-height: 270px;
        }
    }

    @media screen and (max-width: 1000px) {
        .top-section-wrapper {
            .beat-name {
                font-size: 34px;
            }
            .general-info-item {
                padding: 7px 0;
            }
        }
        .licenses-wrapper {
            .beat-license-container {
                min-width: 175px;
                margin-left: 5px;
                margin-right: 5px;
            }
            &.max-licenses {
                .beat-license-container {
                    min-width: 140px;
                    margin-left: 5px;
                    margin-right: 5px;
                    .license-container {
                        min-height: 170px;
                    }
                    .license-name {
                        font-size: 12px;
                    }
                    .price {
                        font-size: 24px;
                    }
                    .file-type-wrapper {
                        font-size: 12px;
                    }
                    .buy-button {
                        font-size: 12px;
                        .full-wrapper {
                            width: 70% !important;
                        }
                        .discount-icon-wrapper {
                            width: 30%;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        .top-section-wrapper {
            .beat-info-wrapper {
                padding-left: 10px;
            }
            .beat-name {
                font-size: 28px;
            }
            .general-info-title {
                font-size: 18px;
            }
            .general-info-heading {
                min-width: 100px;
            }
        }
        .mobile-licenses-wrapper {
            margin-bottom: 40px;
            .mobile-beat-license-container {
                margin-bottom: 20px !important;
            }
        }

        .discounts-wrapper{
            display: unset !important;
            margin-left: unset !important;
            margin-right: unset !important;
            margin-bottom:  unset !important;
            align-items:  unset !important;
            .beat-discount-container {
                flex: unset !important;
                max-width: unset !important;
                margin: unset !important;
                margin-bottom: 20px !important;
            }
        }
    }
    @media screen and (max-width: 500px) {
        .top-section-wrapper {
            display: block;
            .beat-name-wrapper {
                margin: 30px 0 20px;
            }
            .general-info-heading {
                min-width: 120px;
                svg {
                    margin-right: 2px;
                }
            }
        }
    }
}
</style>

<template>
<div v-if="beat" class="beat-page" @click="hideCollapse()">
    <div class="bg-image-overlay" :style="$pageBackgroundOverlay"></div>
    <div class="bg-image" :style="{'background-image': 'url(' +  beat.image(600) + ')'}">
        <div class="bg-image-gradient" :style="$pageBackgroundOverlay"></div>
    </div>

    <div class="page-content padding">
        <div class="top-section-wrapper">
            <div class="beat-image-wrapper" @click="play()">
                <img class="beat-image" :src="beatImage">
                <div class="item-overlay center" >
                    <div id="circle-container">
                        <div class="quarter top-right" :style="$itemPlayButtonStyle"></div>
                        <div class="quarter bottom-left" :style="$itemPlayButtonStyle"></div>
                        <button v-if="isPlaying == true" class="btn-playpause"  @click.stop="beat.pause()" :style="$itemPlayButtonStyle">
                            <font-awesome-icon icon="pause"></font-awesome-icon>
                        </button>

                        <button v-else class="btn-playpause"  @click.stop="beat.play()" :style="$itemPlayButtonStyle">
                            <font-awesome-icon icon="play"></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="beat-info-wrapper">
                <div class="beat-name-wrapper">
                    <h1 class="beat-name" :style="$mainPrimaryTextStyle">{{beat.name}}</h1>
                    <div class="beat-name-buttons">
                        <download-button v-if="beat.freeDownload" :item="beat"></download-button>
                        <share-button :item="beat" :style="$mainSecondaryTextStyle"></share-button>
                    </div>
                </div>
                <div :style="$highlightColor" class="general-info-title">GENERAL INFO</div>
                <div :style="$mainSecondaryTextStyle" class="general-info-wrapper">
                    <div class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="clock"></font-awesome-icon> Duration</div>
                        <div class="general-info-value">{{beat.duration}}</div>
                    </div>
                    <div v-if="beat.bpm > 0" class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="music"></font-awesome-icon> Tempo</div>
                        <div class="general-info-value">{{beat.bpm}}</div>
                    </div>
                    <div class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="compact-disc"></font-awesome-icon> Genre</div>
                        <div class="general-info-value">
                            <router-link :to="{'path': beatsPagePath, query: {'genre': beat.genre.alias}}" class="general-info-link">{{beat.genre.name}}</router-link>
                        </div>
                    </div>
                    <div v-if="beat.key" class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="music-alt"></font-awesome-icon> Key</div>
                        <div class="general-info-value">{{beat.key}}</div>
                    </div>
                    <div v-if="beat.tempo" class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="music"></font-awesome-icon> BPM</div>
                        <div class="general-info-value">{{beat.tempo}}</div>
                    </div>
                    <div v-if="beat.moods.length > 0" class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="heart"></font-awesome-icon> Moods</div>
                        <div class="general-info-value">
                            <router-link :to="{'path': beatsPagePath, query: {'moods': mood.name}}" v-for="(mood,index) in beat.moods" :key="index" class="general-info-link">{{mood.name}}</router-link>
                        </div>
                    </div>
                    <div v-if="beat.tags.length > 0" class="general-info-item">
                        <div class="general-info-heading"><font-awesome-icon icon="hashtag"></font-awesome-icon> Tags</div>
                        <div class="general-info-value">
                            <router-link :to="{'path': beatsPagePath, query: {'tags': tag.name}}" v-for="(tag,index) in beat.tags" :key="index" class="general-info-link">#{{tag.name}}</router-link>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <h1 class="licenses-title" :style="$highlightColor">Pricing & licenses</h1>

        <div class="licenses-wrapper hidden-sm-down" id="licenses-parent" :class="{'max-licenses': beat.activeLicenses >= 5}">
            <template v-for="price in beat.orderedPricing()" v-if="price.license.isAllowedOffers() || price.isSaleable()">
                <license-row class="hidden-sm-down" :beat="beat" :price="price" :collapseId="'beat-page-'+price.license.id" :key="price.license.id"></license-row>
            </template>

            <!--TODO: Check implementation once implemented in backend-->
            <!--<div v-if="beat.youTubeVideoId" style="position: relative;-->
                        <!--padding-bottom: 56.25%;-->
                        <!--padding-top: 25px;-->
                        <!--max-width: 1280px;-->
                        <!--margin: auto;">-->
                <!--<iframe style="position: absolute;-->
                        <!--top: 0;-->
                        <!--left: 0;-->
                        <!--width: 100%;-->
                        <!--height: 100%;-->
                        <!--max-height: 720px;" width="640" height="360" :src="youTubeEmbedUrl"></iframe>-->
            <!--</div>-->
        </div>

         <div class="mobile-licenses-wrapper hidden-md-up row">
            <template v-for="price in beat.orderedPricing()" v-if="price.license.isAllowedOffers() || price.isSaleable()">
                <mobile-license-row class="hidden-md-up" :beat="beat" :price="price" :collapseId="'beat-page-'+price.license.id" :key="price.license.id"></mobile-license-row>
            </template>
         </div>
        <!-- <div v-if="haveDiscounts.length" class="divider" :style="$customBorderColor(0.3)"></div> -->
        <!-- <discount-row v-if="haveDiscounts.length" :prices="prices"></discount-row> -->

        <div class="row">
            <div class="col-md-12">
                <RecommendedBeats :show="showRecommended"></RecommendedBeats>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import Configure from './../../mixins/configure'
    import Beat from './../../models/beat'
    import Playlist from './../../classes/playlist'
    import BeatRepository from './../../mixins/beat-repository'
    import RecommendedBeats from './../recommended-beats.vue'
    import ShareButton from './../sharebutton.vue'
    import DownloadButton from './../downloadbutton.vue'
    import LicenseRow from './../beat/licenserow.vue'
    import MobileLicenseRow from './../beat/mobilelicenserow.vue'
    import DiscountRow from './../packagediscounts.vue'

    export default {
        beforeRouteUpdate (to, from, next) {
            let beat = null
            beat = to.params.beat
            this.licenses = null
            this.prices = []
            this.getBeat(beat);
            this.token = this.$store.state.csrfToken
            // just use `this`
            // this.name = to.params.name
            next()
        },
        components: {
            ShareButton, DownloadButton, LicenseRow ,DiscountRow ,RecommendedBeats ,MobileLicenseRow
        },
        created() {
            let beat = null

            if (this.page != undefined && this.page.type == 'beat') {
                beat = this.page.music_id

            } else if (this.$route.params.beat != undefined) {
                beat = this.$route.params.beat
            }

            if (!beat) {
                this.$router.push('/')
            }

            this.getBeat(beat);
            this.token = this.$store.state.csrfToken

        },
        data() {
            return {
                beat: false,
                licenses : null,
                prices : [],
                token : null,
                showRecommended : ab.loggedInUser ? true : false
            }
        },
        computed: {
            beatsPagePath() {
                if (this.$store.state.currentConfig.defaultBeatsPage) {
                    return this.$store.state.currentConfig.defaultBeatsPage.link
                }
                return "/"
            },
            beatImage() {
                if (this.beat) {
                    return (this.$store.state.viewPortWidth > 500) ? this.beat.image(300) : this.beat.image(600)
                }
            },
            youTubeEmbedUrl() {
                if (beat.youTubeVideoId) {
                    return "https://youtube.com/embed/" + beat.youTubeVideoId
                }
            },
            playerActive() {
                return this.$store.state.player.playing
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            isPlaying() {
                return (this.playlistManager.isPlaying(this.beat) && this.playerActive)
            },
            isPaused() {
                return (this.playlistManager.isPlaying(this.beat) && !this.playerActive)
            },
            offerModal() {
                return this.$store.state.offerModal
            },
            shareModal() {
                return this.$store.state.shareModal
            },
            haveDiscounts(){
                return _.filter(this.prices, license => license.discounts.length);
            }
        },
        mixins: [Configure, BeatRepository],
        methods: {
            getBeat(alias) {
                this.$store.commit('toggleLoading')

                this.getUserBeatByAlias(alias)
                    .then((response) => {
                        this.beat = new Beat(response.data.item)
                        this.$store.commit("singleMusicPageName", {name: this.beat.name})
                        this.$store.state.playlistManager.setPagePlaylist(new Playlist([this.beat], "beat-" + this.beat.id, "beat-" + this.beat.id));
                        this.licenses = this.beat.orderedPricing();
                        this.licenses.forEach(element => {
                            this.prices.push(element.license);
                        });

                        this.$store.commit('toggleLoading')
                    })
                    .catch((e) => {
                        this.$store.commit('toggleLoading')
                        this.$router.push('/')
                    })
            },
            offer(beat, price) {
                this.$store.commit("offerable", {offerable: {
                    beat,
                    price
                }})

                if (this.offerModal) {
                    this.offerModal.modal('show')
                }
            },
            hover(isHovering) {
                this.$data.$hover.itemPlayButton = isHovering
            },
            play(){
                if(this.isPlaying){
                    this.beat.pause()
                }else{
                    this.beat.play()
                }
            },
            hideCollapse() {
                if (this.$store.state.activePackageDiscount) {
                    $('.collapse.in').collapse('hide')
                    this.$store.commit('activeDiscountCollapse', null)
                }
            }

        }

    }
</script>
